// @flow
import { takeEvery, put, call } from 'redux-saga/effects';

import {
  getArrayResource,
  updateResource,
  createResource
} from '@redux/components/ApiRequest/actions';

import { mainApiUrl } from '@lib';
import { isEmpty } from 'lodash';

import {
  FILTER_FACILITY_REQUEST,
  CREATE_APPOINTMENT,
  UPCOMING_APPOINTMENT_REQUEST,
  UPDATE_APPOINTMENT
} from './constants';

import {
  updateFilterFacilities,
  errorFilterFacilities,
  updateUpcomingAppointments,
  requestUpcomingAppointmentsError,
  updatedAppointment,
  updateAppointmentError,
  appointmentCreated,
  errorCreateAppointment
} from './actions';

import type { Action } from '../types';

export function* getResourceActionForFilterFacility({
  patient_id,
  budget_type,
  city,
  facility_id,
  department,
  page,
  per_page
}: {
  patient_id: string,
  budget_type: string,
  city: string,
  facility_id: string,
  department: string,
  page: number,
  per_page: number
}): Generator<Function, void, void> {
  const backendQuery: {} = {
    patient_id,
    budget_type,
    city,
    facility_id: isEmpty(facility_id) ? undefined : facility_id,
    department: isEmpty(department) ? undefined : department,
    page
  };

  const url: string = `${mainApiUrl}/v1/hospital_specialities`;

  yield put(
    getArrayResource(url, updateFilterFacilities, errorFilterFacilities, {
      params: {
        ...backendQuery,
        per_page: per_page || 7
      }
    })
  );
}

export function* getResourceActionForUpcomingAppointments(): Generator<Function, void, void> {
  const url: string = `${mainApiUrl}/v1/patient_appointments/upcoming_appointments`;

  yield put(getArrayResource(url, updateUpcomingAppointments, requestUpcomingAppointmentsError));

  if (typeof window !== 'undefined') {
    yield call(window.scrollTo, 0, 0);
  }
}

export function* createResourceActionForAppointment(payload: {
  first_name: string,
  last_name: string,
  age: number,
  gender: string,
  department: string,
  medical_notes: string,
  attachment_ids: string,
  illness_kind: any,
  time_from: string,
  time_to: string,
  duration: number,
  billing_type: string,
  treatment_type: any,
  files_attributes: any,
  facility_id: string
}): Generator<Function, void, void> {
  yield put(
    createResource(
      `${mainApiUrl}/v1/patient_appointments`,
      { patient_appointment: payload },
      appointmentCreated,
      errorCreateAppointment
    )
  );
}

export function* updateAppointmentFlow(payload: {
  is_active: boolean,
  id: string
}): Generator<Function, void, void> {
  yield put(
    updateResource(
      payload.id,
      `${mainApiUrl}/v1/patient_appointments/${payload.id}`,
      { patient_appointment: payload },
      updatedAppointment,
      updateAppointmentError
    )
  );
}

export function* facilityFilterFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case FILTER_FACILITY_REQUEST:
      yield call(getResourceActionForFilterFacility, action.payload);
      break;

    case CREATE_APPOINTMENT:
      yield call(createResourceActionForAppointment, action.payload);
      break;

    case UPCOMING_APPOINTMENT_REQUEST:
      yield call(getResourceActionForUpcomingAppointments, action);
      break;

    case UPDATE_APPOINTMENT:
      yield call(updateAppointmentFlow, action.payload);
      break;

    default:
      break;
  }
}

function* skillsWatcher(): Generator<Function, void, Action> {
  yield takeEvery(
    [FILTER_FACILITY_REQUEST, CREATE_APPOINTMENT, UPCOMING_APPOINTMENT_REQUEST, UPDATE_APPOINTMENT],
    facilityFilterFlow
  );
}

export default skillsWatcher;
